// ------------------------------------------------------------------------------------
// 指導員サイト 教習生編集画面の「データ取得」ボタン処理
// Profitから対象の教習生データを取得する
//
export const buildRequest = (coreSystemNumber) => {
  const xmlHR = new XMLHttpRequest();
  const token = document.getElementsByName('csrf-token')[0].content;
  const regexp = new RegExp('/([^/]*)/*');
  const schoolName = regexp.exec(window.location.pathname)[1];
  const url = `${window.location.protocol}//${window.location.host}/api/core_system/profit/v1/${schoolName}/student/${coreSystemNumber}`;

  xmlHR.open('GET', url, true);
  xmlHR.setRequestHeader('X-CSRF-Token', token);

  return xmlHR;
};

export const showAlert = (message = '') => {
  alert(`教習生情報の取得に失敗しました。${message}`);
};

export const getFields = () => {
  const coreSystemNumberField = document.getElementById('student_core_system_number');
  const familyNameField = document.getElementById('student_family_name');
  const familyNameKanaField = document.getElementById('student_family_name_kana');
  const givenNameField = document.getElementById('student_given_name');
  const givenNameKanaField = document.getElementById('student_given_name_kana');
  const emailField = document.getElementById('student_email');
  const entranceDateField = document.getElementById('student_entrance_date');
  const statusField = document.getElementById('student_status');
  const phoneField = document.getElementById('student_phone'); // SMSオプションでnullかもしれない
  const licenseTypeField = document.getElementById('student_license_type_id');

  return {
    coreSystemNumberField,
    familyNameField,
    familyNameKanaField,
    givenNameField,
    givenNameKanaField,
    emailField,
    entranceDateField,
    statusField,
    phoneField,
    licenseTypeField,
  };
};

// 連絡先を「電話番号」に切り替える（メールが無く電話番号しかない場合）
export const switchContactToPhone = () => {
  const studentRadioPhone = document.getElementById('student_contact_phone');
  const studentFormGroupEmail = document.getElementById('student-form-group-email');
  const studentFormGroupPhone = document.getElementById('student-form-group-phone');
  const studentInputEmail = document.getElementById('student_email');
  const studentInputPhone = document.getElementById('student_phone');

  studentRadioPhone.checked = true;
  studentFormGroupEmail.style.display = 'none';
  studentFormGroupPhone.style.display = '';
  studentInputEmail.disabled = true;
  studentInputPhone.disabled = false;
};

export const setStudentFieldValues = (values, fields = getFields()) => {
  // MEMO: Obicはcore_system_numberは同期しないので合わせる
  const {
    familyNameField,
    familyNameKanaField,
    givenNameField,
    givenNameKanaField,
    emailField,
    entranceDateField,
    statusField,
    phoneField, // SMSオプションでnullの場合あり
    licenseTypeField,
  } = fields;

  familyNameField.value = values.family_name;
  familyNameKanaField.value = values.family_name_kana;
  givenNameField.value = values.given_name;
  givenNameKanaField.value = values.given_name_kana;

  if (values.email) {
    emailField.value = values.email;
  }
  entranceDateField.value = values.entrance_date;
  statusField.value = values.status;

  // SMSオプションONの場合のみ
  if (phoneField && values.phone) {
    phoneField.value = values.phone;

    // phoneしかないときだけphoneを選択する
    if (!values.email) {
      switchContactToPhone();
    }
  }

  licenseTypeField.value = values.license_type_id;
};

export const changeTargetElementDisabledStatus = (target, isDisable) => {
  if (target === null) return;

  if (isDisable) {
    target.setAttribute('disabled', true);
  } else {
    target.removeAttribute('disabled');
  }
};

// メール送信ボタンのdisabledを解除するために自動入力された値を取得してメアドか電話番号があれば解除
export const removeDisabledFromSubmitWithEmailBtn = (phone, email, submitWithEmailBtn) => {
  if (phone) {
    const contactValue = email.value || phone.value;
    changeTargetElementDisabledStatus(submitWithEmailBtn, !contactValue);
  } else {
    changeTargetElementDisabledStatus(submitWithEmailBtn, !email.value);
  }
};

export const setHoldingLicenseTypes = (values) => {
  document.querySelectorAll('.holding-license-type-ids:checked').forEach((e) => e.click());
  const licenseTypIds = Array.from(document.getElementsByClassName('holding-license-type-ids'));

  licenseTypIds.forEach((license) => {
    if (values === license.id) license.click();
  });
};

export const clearCompleteLessonSlots = () => {
  document.querySelectorAll('.completed-lesson-slot-checkbox:checked').forEach((e) => e.click());
};

export const setCompleteLessonSlots = (values) => {
  clearCompleteLessonSlots();

  const lessonSlotsFirst = Array.from(document.getElementsByClassName('lesson-slot-first'));
  const lessonSlotsSecond = Array.from(document.getElementsByClassName('lesson-slot-second'));

  lessonSlotsFirst.forEach((lessonSlot) => {
    if (values.lesson_slot_codes.includes(lessonSlot.id)) lessonSlot.click();
  });

  const provisionalLicenseCheckBox = document.getElementById('provisional_license');
  // '0' or '1': 仮免あり
  if (values.provisional_license === '1') {
    provisionalLicenseCheckBox.click();
  }

  lessonSlotsSecond.forEach((lessonSlot) => {
    if (values.lesson_slot_codes.includes(lessonSlot.id)) lessonSlot.click();
  });
};

export const base64ToBlob = (base64, contentType = 'image/jpeg') => {
  // Base64文字列をバイナリデータに変換
  const binaryString = window.atob(base64);
  const byteNumbers = new Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i += 1) {
    byteNumbers[i] = binaryString.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: contentType });
};

export const downloadAndAttachFaceImage = (faceImageBase64) => {
  const faceImagePreview = document.getElementById('face-image-preview');
  const faceInput = document.getElementById('student_face_image_file');

  if (!faceImagePreview) return;

  if (faceImageBase64) {
    faceImagePreview.innerHTML = '';

    try {
      const blob = base64ToBlob(faceImageBase64);
      const url = URL.createObjectURL(blob);

      const img = document.createElement('img');
      img.src = url;
      img.style.maxWidth = '100%';
      img.onerror = () => {
        faceImagePreview.innerHTML = '<div class="text-muted small">顔写真読み込み失敗</div>';
        URL.revokeObjectURL(url);
      };
      faceImagePreview.appendChild(img);

      // Profit画像をfile inputにセット
      if (faceInput) {
        const filename = `profit_face_${Date.now()}.jpg`;
        const file = new File([blob], filename, { type: 'image/jpeg' });

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        faceInput.files = dataTransfer.files;
      }
    } catch {
      showAlert(`(顔写真取得失敗)`);
    }
  }
};

export default () => {
  const form = document.getElementById('student-form');
  const button = document.getElementById('get-core-system-students');
  const email = document.getElementById('student_email');
  const phone = document.getElementById('student_phone'); // SMSオプションでnullかもしれない
  const submitWithEmailBtn = document.getElementById('send-email-btn');

  if (!form || !button) return;

  const coreSystem = button.dataset?.coreSystem;
  if (coreSystem !== 'profit_api') return;

  button.addEventListener('click', () => {
    button.classList.add('disabled');

    const fields = getFields();
    const {
      coreSystemNumberField,
      familyNameField,
      familyNameKanaField,
      givenNameField,
      givenNameKanaField,
      emailField,
      statusField,
    } = fields;

    const coreSystemNumber = coreSystemNumberField.value;

    // 教習生番号未入力の場合
    if (!coreSystemNumber) return;

    // 既に入力された項目がある場合
    const completedLessonSlotsSelector = '.completed-lesson-slot-checkbox';
    const completedLessonSlots = document.querySelectorAll(
      `${completedLessonSlotsSelector}:checked`,
    );

    const isFilled =
      familyNameField.value ||
      familyNameKanaField.value ||
      givenNameField.value ||
      givenNameKanaField.value ||
      emailField.value ||
      statusField.value !== 'before_entry' ||
      completedLessonSlots.length > 0;

    if (
      isFilled &&
      !window.confirm('既に入力された項目が存在します。上書きしてもよろしいですか？')
    ) {
      return;
    }

    const request = buildRequest(coreSystemNumber);
    request.onerror = showAlert;
    request.onload = () => {
      button.classList.remove('disabled');
      if (request.status !== 200) {
        let errorMessage = '';
        try {
          errorMessage = `(${JSON.parse(request.responseText).profit})`;
        } catch {
          // レスポンスがJSONでない場合はエラーメッセージを空のままにする
        }
        showAlert(errorMessage);

        return;
      }

      const response = JSON.parse(request.responseText);
      setStudentFieldValues(response.student, fields);
      removeDisabledFromSubmitWithEmailBtn(phone, email, submitWithEmailBtn);

      // 顔写真を表示＆フォームにセット
      if (response.face_image_base64) {
        downloadAndAttachFaceImage(response.face_image_base64);
      }

      if (response.holding_license_type) {
        setHoldingLicenseTypes(response.holding_license_type);
      }
      if (document.querySelectorAll(completedLessonSlotsSelector).length > 0) {
        setCompleteLessonSlots(response.attendances);
      }
    };
    request.send();
  });
};
